import { useState } from 'preact/hooks'

function CartAgeConfirm({ label, value, isChecked, id, onSelect, className }) {
  const [checked, setChecked] = useState(isChecked)

  const handleSelect = () => {
    setChecked(!checked)
    onSelect(!checked)
  }
  return (
    <div className={className}>
      <div className="relative flex items-center checkbox-input">
        <input id={id} className="checkbox-input__input" type="checkbox" value={value} checked={checked} onInput={handleSelect} />
        <label for={id} className="checkbox-input__label">
          {label}
        </label>
      </div>
    </div>
  )
}

export default CartAgeConfirm
